import React from 'react'

const DropdownIcon = () => {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5 5.75003C10.5 5.75003 7.92231 9.25 7 9.25C6.07763 9.25 3.5 5.75 3.5 5.75" stroke="#202327" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

export default DropdownIcon
